import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import usersActions from '../../redux/user/actions';
import employeesActions from '../../redux/employee/actions';
import UserList from '../../components/UserList';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import ContentPage from '../ContentPage';
import { getRoles } from '../../redux/permissions/selectors';
import permissionsActions from '../../redux/permissions/actions';
import LoadingOverlay from '../../components/LoadingOverlay';
import './Users.scss';

class Users extends Component {
  componentDidMount() {
    const { dealerId } = this.props.match.params;
    const { employee, user } = this.props;
    if (dealerId && !user.fetching) {
      this.props.actions.usersRequest(dealerId);
    } else if (!employee.fetching) {
      this.props.actions.employeesRequest();
    }
  }

  render() {
    const { dealer, user, employee, actions, isEmployeeRoute } = this.props;
    const dealerProp = isEmployeeRoute ? {} : dealer;
    const userList = isEmployeeRoute ? employee.employees : user.users;
    const deleteUserAction = isEmployeeRoute
      ? actions.deleteEmployeeRequest
      : actions.deleteUserRequest;
    return (
      <SidebarContainer title="Users" logo={dealerProp.logo}>
        <div className="users-table">
          {dealerProp.id && (
            <DealerNav dealer={dealerProp} user={user.currentUser} />
          )}
          <LoadingOverlay active={employee.fetching}>
            <UserList
              showCrmUserId={!isEmployeeRoute}
              dealer={dealerProp}
              list={userList}
              error={user.error}
              fetching={user.fetching}
              onDelete={deleteUserAction}
              onUnlock={actions.unlockUserRequest}
              history={this.props.history}
            />
          </LoadingOverlay>
        </div>
      </SidebarContainer>
    );
  }
}

Users.propTypes = {
  user: PropTypes.object,
  employee: PropTypes.object,
  isEmployeeRoute: PropTypes.bool,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ user, employee, dealers, permissions }) => ({
  user,
  employee,
  dealer: dealers.dealer,
  roles: getRoles(permissions),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...usersActions,
      ...employeesActions,
      ...permissionsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Users));
